
const formLabels = (): void => {
  const formElems = document.querySelectorAll('[data-label-inside')

  const modifyLabel = (elem: HTMLFormElement, method: string) => {
    if(!elem.id && elem.hasAttribute('[data-label-inside]')) return
    const label = document.querySelector(`[for="${elem.id}"]`)
    if(!label) return
    label.classList[method]('label-visible')
    elem.classList[method]('form-label-visible')
  }

  formElems.forEach((elem: HTMLFormElement) => {
    elem.addEventListener('focus', () => {
      modifyLabel(elem, 'add')
    })
    elem.addEventListener('blur', () => {
      modifyLabel(elem, 'remove')
    })
  });
} 

export default formLabels